import { useState, useContext } from 'react'
import { Context } from '../../../../index'
import { t } from 'i18next'
import { toast } from 'react-toastify';
import responseNotify from '../../../../hooks/responseNotify';

const Transfers = () => {
    const {store} = useContext(Context)
    const [steamIDInput, setSteamIDInput] = useState<any>('')
    const [transferSumInput, setTransferSumInput] = useState<any>('')
    const [receiver, setReceiver] = useState<string>('mixa')
    const [verify, openVerify] = useState<boolean>(false)
    
    const user = store.user
    const validateInput = () => {
        const validateYourself = store.user.steamID64 != steamIDInput
        const validateInput = ( 76561100000000000 <= steamIDInput && steamIDInput <= 76600000000000000 ) 
            && steamIDInput.length === 17
            && transferSumInput <= user.balanceDonate 
            && transferSumInput > 0
        if ( validateYourself && validateInput ) return true
        else return false
    }
    async function preTransfer(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault()
        if (validateInput()) {
            const receiver = await store.getUsernameById(steamIDInput)
            if (!receiver) return toast.error(t(`Store.response.TRANSFER_RECEIVER_NOT_FOUND`))
            setReceiver(receiver)
            openVerify(true)
        }
    }
    async function transfer() {
        const response = await store.profileTransfer(steamIDInput, transferSumInput)
        responseNotify({response, success: ['profile.transfer.status.success']})
        setSteamIDInput('')
        setTransferSumInput('')
        openVerify(false)
    }

    return (
        <div className="transfers">
            {verify && 
            <div className="xbox__div-2 transfers_verify">
                <div className="transfers_verify-text">{t('profile.transfer.confirm', {count: transferSumInput})} <span className="transfers_verify-receiver">{receiver}</span></div>
                <div className="xbox__div-2 transfers_verify_btns">
                    <button className="button-2 transfers_verify_btn cancel" onClick={e => openVerify(false)}>{t('defaults.cancel')}</button>
                    <button className="button-2 blue transfers_verify_btn active yes" onClick={e => transfer()}>{t('defaults.transfer')}</button>
                </div>
            </div>}
            {!verify && <div className="transfers_main">
                <form className="xbox__div-2 transfers__information" onSubmit={e => preTransfer(e)}>
                    <div className="input-1 input_steamid">
                        <svg className='input-before-svg svg-stroke' viewBox="2 2 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.5 19.5 20 21m-9-7a7 7 0 0 0-7 7h7m8-3.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0zM15 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0z" stroke="#5C5C68" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                        <input id="input_steamid" type="text" pattern="[0-9]*" maxLength={17} placeholder={t('profile.transfer.placeholderSteamID')} autoComplete="off" value={steamIDInput} onChange={e => setSteamIDInput(e.target.value.replace(/[^0-9]/g,''))} />
                    </div>
                    <div className="input-1 input_sum">
                        <div className="input-before-text">₽</div>
                        <input id="input_sum" type="text" maxLength={8} placeholder={t('profile.transfer.placeholderSum')} autoComplete="off" value={transferSumInput!=0 ? new Intl.NumberFormat('ru-RU').format(transferSumInput): ''} onChange={e => setTransferSumInput(e.target.value.replace(/[^0-9]/g,''))} />
                    </div>
                    <button className="button-2 blue" disabled={validateInput() ? false:true} type='submit'>
                        {t('profile.transfer.apply')}
                    </button>
                </form>
                <div className="transfer_tip">
                    <svg className="input-before-svg" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-.696-3.534c.63 0 1.332-.288 2.196-1.458l.911-1.22a.334.334 0 0 0-.074-.472.38.38 0 0 0-.505.06l-1.475 1.679a.241.241 0 0 1-.279.061.211.211 0 0 1-.12-.244l1.858-7.446a.499.499 0 0 0-.575-.613l-3.35.613a.35.35 0 0 0-.276.258l-.086.334a.25.25 0 0 0 .243.312h1.73l-1.476 5.922c-.054.234-.144.63-.144.918 0 .666.396 1.296 1.422 1.296zm1.83-10.536c.702 0 1.242-.414 1.386-1.044.036-.144.054-.306.054-.414 0-.504-.396-.972-1.134-.972-.702 0-1.242.414-1.386 1.044a1.868 1.868 0 0 0-.054.414c0 .504.396.972 1.134.972z" fill="#000000"></path></svg>
                    <div className="transfer_tip-text">{t('profile.transfer.available', {bonus: new Intl.NumberFormat('ru-RU').format(Number(user.balanceDonate.toFixed(2)))})}</div>
                </div>
            </div>}
        </div>
        
    )
}

export default Transfers